/**
 * 独立页配置
 * 独立页是指：无遥望云侧边栏，顶部区域，底部区域。只有业务内容区域
 */
export interface StandalonePagesConfigProp {
  /** 页面名称 */
  title: string;
  /** 页面路径 */
  path: string;
  /** 页面所在遥望云中模块的ID */
  moduleId: string;
  /** 是否启用静态化 */
  isStatic: boolean;
  /** 所属业务名 对应config中 项目名 */
  projectName: 'broadcast' | 'dianhu' | 'dianlang' | 'finance' | 'goods' | 'marketing' | 'proauth' | 'supply' | 'customerservice';
}

export const standalonePages: StandalonePagesConfigProp[] = [
  {
    title: '直播开播等待页',
    path: '/Dashboard/LiveWaiting',
    moduleId: 'DC40DE1C973C76221351624535898130',
    isStatic: true,
    projectName: 'dianhu',
  },
  {
    title: '实时直播大屏',
    path: '/dashboard',
    moduleId: 'DC40DE1C973C76221351624535898130',
    isStatic: true,
    projectName: 'dianhu',
  },
  {
    title: '场控大屏',
    path: '/fieldControl',
    moduleId: 'DC40DE1C973C76221351624535898130',
    isStatic: true,
    projectName: 'dianhu',
  },
  {
    title: '直播驾驶舱',
    path: '/liveCockpit',
    moduleId: 'DC40DE1C973C76221351624535898130',
    isStatic: true,
    projectName: 'dianhu',
  },
  {
    title: '投放驾驶舱',
    path: '/toufangCockpit',
    moduleId: 'DC40DE1C973C76221351624535898130',
    isStatic: true,
    projectName: 'dianhu',
  },
  {
    title: '直播复盘',
    path: '/liveReview',
    moduleId: 'DC40DE1C973C75221302164775719250',
    isStatic: true,
    projectName: 'dianhu',
  },
  {
    title: '直播排品',
    path: '/broadcast/liveScheduling',
    moduleId: 'DC40DE1C973C75221302164775719250',
    isStatic: true,
    projectName: 'broadcast',
  },
  {
    title: '直播大屏',
    path: '/broadcast/liveBigScreen',
    moduleId: 'DC40DE1C973C75221302164775719250',
    isStatic: true,
    projectName: 'broadcast',
  },
  {
    title: '商品分析-选品参谋-商品详情页',
    path: '/goodsAnalysis/GoodsStaff/GoodsDetail',
    moduleId: 'DC40DE1C973C76221351624535898130',
    isStatic: true,
    projectName: 'dianhu',
  },
  {
    title: '用户分析-粉丝画像',
    path: '/userAnalysis/fansPortrait',
    moduleId: 'DC40DE1C973C76221351624535898130',
    isStatic: true,
    projectName: 'dianhu',
  },
  {
    title: '大字报-表单配置',
    path: '/bigCharacter/formConfig',
    moduleId: 'DC40DE1C973C75221302164775719250',
    isStatic: true,
    projectName: 'broadcast',
  },
  {
    title: '大字报-大屏',
    path: '/bigCharacter/screen',
    moduleId: 'DC40DE1C973C75221302164775719250',
    isStatic: true,
    projectName: 'broadcast',
  },
  {
    title: '大字报-预览',
    path: '/bigCharacter/screenPreview',
    moduleId: 'DC40DE1C973C75221302164775719250',
    isStatic: true,
    projectName: 'broadcast',
  },
  {
    title: '大字报-历史记录',
    path: '/bigCharacter/history',
    moduleId: 'DC40DE1C973C75221302164775719250',
    isStatic: true,
    projectName: 'broadcast',
  },
  {
    title: '弹幕玩法',
    path: '/broadcast/danmaku',
    moduleId: 'DC40DE1C973C75221302164775719250',
    isStatic: true,
    projectName: 'broadcast',
  },
  {
    title: '直播间福利销量',
    path: '/broadcast/benefitSales',
    moduleId: 'DC40DE1C973C75221302164775719250',
    isStatic: true,
    projectName: 'broadcast',
  },
  {
    title: '直播间门禁',
    path: '/broadcast/electronicDoor',
    moduleId: 'DCE0584D733DB7835324461526777110',
    isStatic: true,
    projectName: 'broadcast',
  },
  {
    title: 'SOP编辑器',
    path: '/customerCare/sopRuleEngine',
    moduleId: 'DC40DE1C973C80221301711888117960', // dev
    isStatic: true,
    projectName: 'customerservice',
  },
  {
    title: '智能服务导航',
    path: '/customerCare/sopChrome',
    moduleId: 'DC40DE1C973C80221301711888117960', // dev
    isStatic: true,
    projectName: 'customerservice',
  },
  {
    title: '大屏详情',
    path: '/dataScreen/detail',
    moduleId: 'DC40DE1C973C75221302164775719250', // dev
    isStatic: true,
    projectName: 'broadcast',
  },
  {
    title: '大屏数据展示',
    path: '/dataScreen/display',
    moduleId: 'DC40DE1C973C75221302164775719250', // dev
    isStatic: true,
    projectName: 'broadcast',
  },
  {
    title: '新建评估表',
    path: '/liveAuthorManage/liveAuthorIP/addMEvalLibrary',
    moduleId: 'DC854A6A143281550291595191335067', // dev
    isStatic: true,
    projectName: 'broadcast',
  },
  {
    title: '评估详情',
    path: '/liveAuthorManage/liveAuthorIP/mEvalLibrary',
    moduleId: 'DC854A6A143281550291595191335067', // dev
    isStatic: true,
    projectName: 'broadcast',
  },
  {
    title: 'AI货盘',
    path: '/broadcast/AIPallet',
    moduleId: 'DC40DE1C973C75221302164775719250',
    isStatic: true,
    projectName: 'broadcast',
  },
];
